import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const User = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  function tog_list() {
    setmodal_list(!modal_list);
  }

  const [machineData, setMachineData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [roles, setRoles] = useState([]);

  const fetchCompany = async () => {
    try {
      setIsLoading(true);
      const response = await fetch("https://api.hanoch.in/api/company");

      if (response.ok) {
        const data = await response.json();
        setCompanyData(data);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await fetch(
          "https://api.hanoch.in/users/user-role-choice/"
        );

        if (response.ok) {
          const data = await response.json();
          setRoles(data?.roles || []);
        } else {
          console.error("Failed to fetch roles");
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  const fetchMachine = async (companyId) => {
    try {
      const response = await fetch(
        `https://api.hanoch.in/api/machines/by-company/?id=${companyId}`
      );

      if (response.ok) {
        const data = await response.json();
        setMachineData(data.data);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching machine data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching machine data:", error);
    }
  };

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    role: "",
    company: "",
    machines: [],
    password: "",
  });

  // FIX: use correct field names from API response (company_name → company id lookup,
  // machine_names is an array of names — keep as-is for display; IDs sent on submit)
  useEffect(() => {
    if (editUser) {
      // Find company id from companyData by matching company_name
      const matchedCompany = companyData.find(
        (c) => c.name === editUser.company_name
      );
      const companyId = matchedCompany ? String(matchedCompany.id) : "";

      // Fetch machines for this company so the select is populated
      if (companyId) {
        fetchMachine(companyId);
      }

      setFormData({
        first_name: editUser.first_name || "",
        last_name: editUser.last_name || "",
        email: editUser.email || "",
        phone: editUser.phone || "",
        role: editUser.role || "",
        company: companyId,
        // machine_names from API is an array of name strings;
        // after fetchMachine resolves, we match by name to get IDs in a separate effect
        machines: [],
        password: "",
      });
    } else {
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        role: "",
        company: "",
        machines: [],
        password: "",
      });
      setMachineData([]);
    }
  }, [editUser, companyData]);

  // Once machineData is loaded for edit, pre-select machines by matching names
  useEffect(() => {
    if (editUser && machineData.length > 0) {
      const machineNames = editUser.machine_names || [];
      const selectedIds = machineData
        .filter((m) => machineNames.includes(m.name))
        .map((m) => String(m.id));
      setFormData((prev) => ({ ...prev, machines: selectedIds }));
    }
  }, [machineData]);

  const authToken = localStorage.getItem("access");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone: formData.phone,
      role: formData.role,
      company: formData.company,
      machines: formData.machines,
      password: formData.password,
    };

    try {
      const apiUrl = editUser
        ? `https://api.hanoch.in/users/users/${editUser.id}/`
        : "https://api.hanoch.in/users/users/";

      const response = await fetch(apiUrl, {
        method: editUser ? "PATCH" : "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();

      if (response.ok) {
        toast.success(responseData.message || "User saved successfully");
        tog_list();
        setEditUser(null);
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          role: "",
          company: "",
          machines: [],
          password: "",
        });
        fetchUser();
      } else {
        toast.error(`Error: ${responseData.error || "Something went wrong"}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Network error. Please try again.");
    } finally {
      // FIX: always reset loading state
      setIsLoading(false);
    }
  };

  const [userData, setUserData] = useState([]);

  const fetchUser = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/users/users/");

      if (response.ok) {
        const data = await response.json();
        // FIX: API wraps list in data.data
        setUserData(data.data || []);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  // FIX: fetch single user details before opening edit modal, to get full data
  const handleEditClick = async (user) => {
    try {
      const response = await fetch(
        `https://api.hanoch.in/users/users/${user.id}/`
      );
      if (response.ok) {
        const data = await response.json();
        setEditUser(data.data || user);
      } else {
        // fallback to list-row data
        setEditUser(user);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      setEditUser(user);
    }
    setmodal_list(true);
  };

  // FIX: delete URL updated to api.hanoch.in with correct path
  const handleDeleteUser = async (userId) => {
    try {
      const response = await fetch(
        `https://api.hanoch.in/users/users/${userId}/`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.ok) {
        toast.success("User Deleted Successfully");
        fetchUser();
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        toast.error("Error deleting user");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUsers = userData.filter(
    (user) =>
      user.first_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      user.last_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const handleInputChangeWrapper = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });

    if (id === "company") {
      setMachineData([]);
      setFormData((prev) => ({ ...prev, company: value, machines: [] }));
      if (value) fetchMachine(value);
    }
  };

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Users" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">Add, Edit & Remove User</h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={() => {
                              setEditUser(null);
                              tog_list();
                            }}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add User
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {isLoading ? (
                      <div className="text-center">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive table-card mt-3 mb-1">
                        <table
                          className="table align-middle table-nowrap"
                          id="customerTable"
                        >
                          <thead className="table-light">
                            <tr>
                              <th className="sort" data-sort="customer_name">
                                User
                              </th>
                              <th className="sort" data-sort="email">
                                Email
                              </th>
                              <th className="sort" data-sort="phone">
                                Phone
                              </th>
                              <th className="sort" data-sort="role">
                                Role
                              </th>
                              <th className="sort" data-sort="company">
                                Company Name
                              </th>
                              <th className="sort" data-sort="machines">
                                Machine Name
                              </th>
                              <th className="sort" data-sort="date">
                                Joining Date
                              </th>
                              <th className="sort" data-sort="action">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody className="list form-check-all">
                            {currentItems.length === 0 ? (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  No content found
                                </td>
                              </tr>
                            ) : (
                              currentItems.map((user, index) => (
                                <tr key={user.id || index}>
                                  <td className="customer_name">
                                    {user.first_name} {user.last_name}
                                  </td>
                                  <td className="email">{user.email}</td>
                                  <td className="phone">{user.phone}</td>
                                  <td>{user.role}</td>
                                  <td>{user.company_name || "—"}</td>
                                  {/* FIX: machine_names is an array */}
                                  <td>
                                    {Array.isArray(user.machine_names)
                                      ? user.machine_names.join(", ") || "—"
                                      : user.machine_names || "—"}
                                  </td>
                                  <td className="date">{user?.date || "—"}</td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      <div className="edit">
                                        <button
                                          className="btn btn-warning"
                                          onClick={() => handleEditClick(user)}
                                        >
                                          Edit
                                        </button>
                                      </div>
                                      <div className="remove">
                                        <button
                                          className="btn btn-danger remove-item-btn"
                                          onClick={() =>
                                            handleDeleteUser(user.id)
                                          }
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages || 1}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add / Edit Modal */}
      <Modal
        isOpen={modal_list}
        toggle={() => {
          setmodal_list(false);
          setEditUser(null);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            tog_list();
            setEditUser(null);
          }}
        >
          {editUser ? "Edit User" : "Add User"}
        </ModalHeader>
        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="first_name" className="form-label">
                First Name
              </label>
              <input
                type="text"
                id="first_name"
                className="form-control"
                placeholder="First Name"
                value={formData.first_name}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="last_name" className="form-label">
                Last Name
              </label>
              <input
                type="text"
                id="last_name"
                className="form-control"
                placeholder="Last Name"
                value={formData.last_name}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Enter Email"
                value={formData.email}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phone" className="form-label">
                Phone
              </label>
              <input
                type="text"
                id="phone"
                className="form-control"
                placeholder="Enter Phone no."
                value={formData.phone}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="role" className="form-label">
                Role
              </label>
              <select
                id="role"
                name="role"
                className="form-control"
                value={formData.role}
                onChange={handleInputChangeWrapper}
                required
              >
                <option value="">Select role</option>
                {roles.map((role) => (
                  <option key={role.value || role} value={role.value || role}>
                    {role.label || role}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="company" className="form-label">
                Company Name
              </label>
              <select
                id="company"
                className="form-control"
                value={formData.company}
                onChange={handleInputChangeWrapper}
                required
              >
                <option value="">Select Company</option>
                {companyData.map((company, index) => (
                  <option key={index} value={company.id}>
                    {company.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="machines" className="form-label">
                Machine Name
              </label>

              {formData.company === "" ? (
                <select className="form-control" disabled>
                  <option>Select a company first</option>
                </select>
              ) : machineData.length === 0 ? (
                <select className="form-control" disabled>
                  <option>No machines available</option>
                </select>
              ) : (
                <select
                  id="machines"
                  className="form-control"
                  multiple
                  value={formData.machines}
                  onChange={(e) => {
                    const selectedOptions = Array.from(
                      e.target.selectedOptions
                    ).map((option) => option.value);
                    setFormData({ ...formData, machines: selectedOptions });
                  }}
                >
                  {machineData.map((machine) => (
                    <option key={machine.id} value={String(machine.id)}>
                      {machine.name}
                    </option>
                  ))}
                </select>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                id="password"
                className="form-control"
                placeholder={editUser ? "Leave blank to keep current" : "Password"}
                value={formData.password}
                onChange={handleInputChangeWrapper}
                required={!editUser}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setmodal_list(false);
                  setEditUser(null);
                }}
              >
                Close
              </button>
              {isLoading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <button
                  type="submit"
                  className="btn btn-success"
                  id="add-btn"
                  onClick={handleSubmit}
                >
                  {editUser ? "Update User" : "Add User"}
                </button>
              )}
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default User;